import * as _ from 'lodash';

export class CompanySearch {
    id: string;
    name: string;
    owner: string;
    cnpj: String;
    group: Number = 0;
    skip: number = 0;
    limit: number = 10;
    totalItems: number = 0;
    active: Boolean = true;
    month: number;
    monthend: number;
    year: number;
    yearend: number;
    companyGroup: String[] = [];
    industries: String[] = [];
    onlyExternalReference: boolean = false;
    onlyActives: boolean = false;
    onlyCustomer: boolean = true;

    constructor(data?) {
        if (data)
            this.populate(data);
    }

    public populate(data) {
        _.forOwn(data, (value, key) => {
            this[key] = value;
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/models/CompanySearch.model.ts